import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';
import { AccountInfo } from '@azure/msal-browser';
import { HttpClient } from '@angular/common/http';
import { UsersService } from '@backend/index';

@Injectable({
  providedIn: 'root',
})
export class AccountService extends BaseService {
  private activeAccountSubject = new BehaviorSubject<AccountInfo | null>(null);
  activeAccount$ = this.activeAccountSubject.asObservable();

  private allAccountSubject = new BehaviorSubject<AccountInfo[] | null>(null);
  allAccounts$ = this.allAccountSubject.asObservable();

  private userRoleCodeSubject = new BehaviorSubject<string | null>(null);
  userRoleCode$ = this.userRoleCodeSubject.asObservable();

  constructor(http: HttpClient, private userService: UsersService) {
    super();
  }

  setActiveAccount(activeAccount: AccountInfo | null) {
    this.activeAccountSubject.next(activeAccount);
  }

  setUserRole() {
    this.userService.getLoggedIn().subscribe((r) => {
      this.userRoleCodeSubject.next(r.data?.roleCode || null);
    });
  }

  getUserRoleCode(): string | null {
    return this.userRoleCodeSubject.value;
  }

  getUserRoleCodeObservable(): Observable<string | null> {
    return this.userRoleCodeSubject.asObservable();
  }
}
